module.exports = __webpack_public_path__ + "static/img/about_h5bg_08_zh.b2c471f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_08_zh.png
// module id = eDMV
// module chunks = 34